import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { ArrowUpRight, Heart, Mail } from 'lucide-react';
import { Download } from 'lucide-react';
import { weddingData } from '../data';

const GOOGLE_FORM_URL = 'https://forms.gle/e4s39YYCr5SfsWSf7';

export const RSVPSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <section ref={ref} className="relative overflow-hidden bg-stone-950 px-6 py-28 text-stone-100 md:py-40">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(251,191,114,0.22),transparent_35%),radial-gradient(circle_at_bottom_right,rgba(244,114,182,0.16),transparent_30%)]" />

      <motion.div
        initial={{ opacity: 0, y: 36 }}
        animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 36 }}
        transition={{ duration: 0.9, ease: 'easeOut' }}
        className="relative mx-auto max-w-5xl"
      >
        <div className="grid gap-10 rounded-[2rem] border border-white/10 bg-white/5 p-8 shadow-[0_30px_120px_rgba(0,0,0,0.35)] backdrop-blur-sm md:grid-cols-[1.1fr_0.9fr] md:p-12">
          <div className="flex flex-col justify-between">
            <div>
              <div className="mb-8 inline-flex items-center gap-3 rounded-full border border-amber-200/20 bg-white/5 px-4 py-2 text-xs uppercase tracking-[0.32em] text-amber-100/80">
                <Heart className="h-4 w-4" />
                RSVP
              </div>

              <h2 className="max-w-xl font-elegant text-4xl leading-tight text-white md:text-5xl lg:text-6xl">
                Join us for the celebration.
              </h2>

              <p className="mt-6 max-w-lg text-lg leading-8 text-stone-300">
                We&apos;ve kept the RSVP experience simple. Use the button to open our form, confirm your details, and send your response directly to us.
              </p>
            </div>

            <div className="mt-10 flex items-center gap-4 text-sm text-stone-400">
              <div className="flex h-11 w-11 items-center justify-center rounded-full bg-white/10">
                <Mail className="h-5 w-5 text-amber-100" />
              </div>
              Your response will be recorded securely in Google Forms.
            </div>
          </div>

          <div className="flex flex-col justify-between rounded-[1.75rem] bg-[#f6efe7] p-6 text-stone-900 md:p-8">
            <div>
              <p className="text-sm uppercase tracking-[0.28em] text-stone-500">Wedding RSVP</p>
              <h3 className="mt-3 font-elegant text-3xl text-stone-900">Share your response with us</h3>
            </div>

            <div className="mt-10">
              <a
                href={GOOGLE_FORM_URL}
                target="_blank"
                rel="noreferrer"
                className="flex w-full items-center justify-center gap-3 rounded-2xl bg-stone-900 px-6 py-4 text-sm font-medium uppercase tracking-[0.24em] text-white transition duration-300 hover:bg-stone-800"
              >
                Open RSVP Form
                <ArrowUpRight className="h-4 w-4" />
              </a>

              <a
                href={weddingData.rsvp.wardrobePlannerUrl}
                download="Wardrobe-Planner.pdf"
                data-testid="wardrobe-planner-btn"
                className="mt-4 inline-flex items-center gap-3 px-8 md:px-10 py-3.5 md:py-4 border border-stone-300 text-stone-900 hover:bg-stone-900/5 transition-all duration-300 font-light uppercase tracking-widest text-xs md:text-sm w-full justify-center rounded-2xl"
              >
                <Download className="w-4 h-4" />
                Wardrobe Planner
              </a>
            </div>
          </div>
        </div>
      </motion.div>
    </section>
  );
};
